import React from 'react';
import { CaptionText, grey600, v2black, v2blue400 } from '@paypalcorp/pp-react';
import glamorous from 'glamorous';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';
import styles from './donation-terms.less';

const TermsList = glamorous(CaptionText)({
  listStyleType: 'disc',
  '& a': {
    color: v2blue400,
  },
});

const Term = glamorous(CaptionText)({
  margin: '10px 0px 10px 10px',
  '& a': {
    color: v2blue400,
  },
});

const TermsOl = glamorous(CaptionText)({
  listStyleType: 'disc',
  textAlign: 'justify',
});

const defaultTermsKey = 'label.donation-enrolled-terms';

export default function DonationTerms(props) {
  const termsKey = props.donationTerms || defaultTermsKey;
  let terms = Array.isArray(props.donationTermsOverride)
    ? props.donationTermsOverride
    : props.i18n(termsKey);

  terms = Array.isArray(terms) ? terms : [];
  const shouldJoin = props.join === undefined ? false : props.join;
  if (shouldJoin) {
    return (
      <ThemeProvider theme='v2'>
        <TermsList dangerouslySetInnerHTML={{ __html: terms.join(' ') }} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme='v2'>
      <TermsOl as='ol' style={{ color: grey600 }}>
        {terms.map((term, index) => {
          return (
            <Term
              as='li'
              key={`donation-term-${index}`}
              className={styles.liTerms}
              style={{ color: v2black }}
              dangerouslySetInnerHTML={{ __html: term }}
            />
          );
        })}
      </TermsOl>
    </ThemeProvider>
  );
}
